import * as React from 'react'

import i18n from 'modules/core/lib/i18n'

import StatsRow from 'modules/timeoff/components/Leaves/Overview/NewStatsCounter/StatsRow'
import type Allowance from 'modules/timeoff/store/models/Allowance'
import type { Cycle } from 'modules/timeoff/store/models/AllowanceStat'
import type AllowanceStat from 'modules/timeoff/store/models/AllowanceStat'

import TakenTooltip from './TakenTooltip'

interface Props {
  allowance: Allowance
  selectedStat: AllowanceStat
  selectedCycle: Cycle
  nextCycle: Cycle | null | undefined
}

const TakenDays = ({ allowance, selectedStat, selectedCycle, nextCycle }: Props) => {
  const stat = selectedStat.toJS()
  const takenDays = stat.used_days
  let usedDays = stat.used_days

  const carryOver = stat.accumulated_carry_over
  const adjustment = stat.incidences
  const proratedDays = stat.prorated_allowance_days
  let remainingCarryover = 0
  let remainingAdjustment = 0
  let remainingDays = 0

  // check if there is a carryover
  if (carryOver > 0) {
    // if there is, get the carry over remainder
    remainingCarryover = carryOver - usedDays

    // in the case that there is more used days than carry over
    if (remainingCarryover < 0) {
      // update the used days removing the carryover used
      usedDays = usedDays - carryOver
      remainingCarryover = 0
    }
  }

  if (adjustment > 0) {
    remainingAdjustment = adjustment - usedDays

    if (remainingAdjustment < 0) {
      usedDays = usedDays - adjustment
      remainingAdjustment = 0
    }
  }

  if (proratedDays > 0) {
    remainingDays = proratedDays - usedDays

    if (remainingDays < 0) {
      usedDays = usedDays - proratedDays
      remainingDays = 0
    }
  }

  const title = allowance.isDays
    ? i18n.t('time_off.taken_tooltip.taken_days')
    : i18n.t('time_off.taken_tooltip.taken_hours')

  return (
    <StatsRow
      title={title}
      amount={takenDays}
      tooltip={
        <TakenTooltip
          allowance={allowance}
          selectedStat={selectedStat}
          remainingCarryover={remainingCarryover}
          remainingAdjustment={remainingAdjustment}
          remainingDays={remainingDays}
          usedDays={usedDays}
          selectedCycle={selectedCycle}
          nextCycle={nextCycle}
        />
      }
    />
  )
}

export default TakenDays
